const iconList = [
  {
    name: 'SmartAdvisor',
    import: () => import('@/assets/icons/feature-smart-advisor.svg'),
  },
  {
    name: 'ROICalculator',
    import: () => import('@/assets/icons/feature-roi-calculator.svg'),
  },
  {
    name: 'CashflowPlanner',
    import: () => import('@/assets/icons/feature-cashflow-planner.svg'),
  },
  {
    name: 'SeedHoldback',
    import: () => import('@/assets/icons/seed-holdback.svg'),
  },
  {
    name: 'GrainfoxToAgresourceRedirect',
    import: () => import('@/assets/icons/grainfox-to-agresource.svg'),
  },
  {
    name: 'GrainfoxLogo',
    import: () => import('@/assets/icons/grainfox-icon.svg'),
  },
  {
    name: 'GrainFoxAIOutlineIcon',
    import: () => import('@/assets/icons/grainfox-ai-outline.svg'),
  },
  {
    name: 'GrainFoxAIDisabledOutlineIcon',
    import: () => import('@/assets/icons/grainfox-ai-disabled-outline.svg'),
  },
  {
    name: 'CustomerCare',
    import: () => import('@/assets/icons/customer-care.svg'),
  },
];

const asyncComponents = {};
iconList.forEach((component) => {
  asyncComponents[component.name] = component.import;
});

export {
  iconList,
  asyncComponents,
};
